import React from "react";
import Stack from "@mui/material/Stack";
import { useAgreementContext } from "../AgreementContext";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { NoteLogPanel } from "../../NoteLog/NoteLogPanel";
import { addDoc, collection, doc, serverTimestamp } from "firebase/firestore";
import { db } from "@poseidon/firebase";
import { Panel } from "@poseidon/ui/components";
import FileManagement from "../../Files/FileManagement";
import config from "@poseidon/utils/config";
import { getDate } from "@poseidon/firebase/timestamp";

const noteLogMapper = (doc) => ({
  ...doc.data(),
  id: doc.id,
  createdAt: getDate(doc.get("createdAt")),
});

async function addNote({ title, body, user, agreement, noteCategory }) {
  const values = {
    title,
    body,
    postedBy: doc(db, "admins", user.uid),
    createdAt: serverTimestamp(),
  };

  await addDoc(
    collection(db, "agreements", agreement.id, noteCategory),
    values
  );
}

const ArrearsMgmt = () => {
  const agreement = useAgreementContext();
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const addNoteHandler =
    ({ message, noteCategory }) =>
    (values, { resetForm }) => {
      try {
        addNote({
          ...values,
          agreement,
          noteCategory,
        }).then(() => {
          resetForm();
          setToast(message);
        });
      } catch (error) {
        setError(error.message);
      }
    };

  const onArrearsNotesAddHandler = addNoteHandler({
    message: "Added Arrears Note",
    noteCategory: "arrearsNotes",
  });
  const { getFileResolver } = config;

  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <NoteLogPanel
        title="Arrears Notes"
        dbPathSlugs={["agreements", agreement.id, "arrearsNotes"]}
        updateHandler={onArrearsNotesAddHandler}
        mapper={noteLogMapper}
      />
      <Panel title="File Upload">
        <FileManagement
          fileCategory="agreement"
          resolveMetadata={getFileResolver("arrearsMgmt")}
          agreementId={agreement.id}
        />
      </Panel>
    </Stack>
  );
};

export default ArrearsMgmt;
